/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Form, Row, Col, Card, Space, Table,
  Input, Button, DatePicker, Typography, message, Flex,
} from "antd";
import { detailColumns } from "./model";
import { SaveOutlined, ArrowLeftOutlined, SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import DeliveryNoteService from "../../../service/ERP/DeliveryNote.service";
import JobOrderService from "../../../service/ERP/JobOrder.service";
import ModalJobOrder from "../../../components/modal/ERP/job-order/ModalJobOrder";
import ModalJOItems from "../../../components/modal/ERP/job-order/ModalJOItems";

const delService = DeliveryNoteService();
const joService  = JobOrderService();

const MyManage = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { config } = location.state || {};
  const isCreate  = config?.action === "create";
  /* โอหมดดูอย่างเดียว — ปิดการแก้ไขทั้งฟอร์ม ส่อนปุ่มบันทึก/ลบแถว */
  const isView = config?.action === "view";

  const [form]            = Form.useForm();
  const [detail, setDetail]           = useState([]);
  const [loading, setLoading]         = useState(false);
  const [openJOModal, setOpenJOModal]       = useState(false);
  const [openJOItemsModal, setOpenJOItemsModal] = useState(false);
  const [joItemsData, setJoItemsData]       = useState([]);

  /* ---- ลบแถวใน detail table ---- */
  const deleteDetail = (seq) => {
    setDetail((prev) =>
      prev.filter((d) => d.seq !== seq).map((d, i) => ({ ...d, seq: i + 1 }))
    );
  };

  /* ---- อัพเดท field ใน detail table ---- */
  const updateDetail = (index, field, value) => {
    setDetail((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  /* ---- เมื่อเลือก JO จาก Modal ---- */
  const handleSelectJO = async (record) => {
    try {
      const res    = await joService.get(record.jocode);
      const result = res.data?.result;
      if (!result || result.length === 0) {
        message.warning("ไม่พบข้อมูล Job Order");
        return;
      }
      const latest = result[result.length - 1];
      form.setFieldsValue({
        jocode:  latest.jocode,
        cuscode: latest.cuscode,
        cusname: latest.cusname,
        brand:   latest.brand,
      });
      setJoItemsData(latest.detail || []);
      setOpenJOItemsModal(true);
    } catch {
      message.error("โหลดข้อมูล JO ไม่สำเร็จ");
    }
  };

  /* ---- เมื่อยืนยันรายการที่เลือกจาก ModalJOItems ---- */
  const handleConfirmJOItems = (selectedItems) => {
    setDetail((prev) => {
      const today = dayjs();
      const newItems = selectedItems.map((d) => {
        const shelfLife = Number(d.shelf_life || 0) > 0 ? Number(d.shelf_life) : 60;
        return {
          seq:             0,
          pg_code:         d.pg_code,
          pg_name:         d.pg_name,
          production_date: today,
          expiry_date:     today.add(shelfLife, "day"),
          carton:          d.carton || 0,
          detail_remark:   "",
        };
      });
      return [...prev, ...newItems].map((d, i) => ({ ...d, seq: i + 1 }));
    });
    setOpenJOItemsModal(false);
  };

  /* ---- โหลดข้อมูลเมื่อ edit ---- */
  const loadData = async (code) => {
    try {
      setLoading(true);
      const res = await delService.get(code);
      const { header, detail: det } = res.data?.data || {};
      if (!header) return;
      form.setFieldsValue({
        delcode:  header.delcode,
        jocode:   header.jocode,
        cuscode:  header.cuscode,
        cusname:  header.cusname,
        brand:    header.brand,
        load_no:  header.load_no,
        dlvdate:  header.dlvdate ? dayjs(header.dlvdate) : null,
        remark:   header.remark,
      });
      setDetail(
        (det || []).map((d) => ({
          ...d,
          production_date: d.production_date ? dayjs(d.production_date) : null,
          expiry_date:     d.expiry_date     ? dayjs(d.expiry_date)     : null,
        }))
      );
    } catch {
      message.error("โหลดข้อมูลไม่สำเร็จ");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isCreate && config?.code) {
      loadData(config.code);
    } else if (isCreate) {
      form.setFieldsValue({ dlvdate: dayjs() });
    }
  }, []);

  /* ---- บันทึก ---- */
  const handleSave = async () => {
    try {
      const values  = await form.validateFields();
      const payload = {
        header: {
          ...values,
          dlvdate: values.dlvdate ? dayjs(values.dlvdate).format("YYYY-MM-DD") : null,
        },
        detail: detail.map((d) => ({
          ...d,
          production_date: d.production_date ? dayjs(d.production_date).format("YYYY-MM-DD") : null,
          expiry_date:     d.expiry_date     ? dayjs(d.expiry_date).format("YYYY-MM-DD")     : null,
        })),
      };
      if (isCreate) {
        await delService.create(payload);
        message.success("บันทึกสำเร็จ");
      } else {
        await delService.update(payload);
        message.success("อัพเดทสำเร็จ");
      }
      navigate(-1);
    } catch (err) {
      if (err?.errorFields) return;
      message.error(err?.response?.data?.message || "บันทึกไม่สำเร็จ");
    }
  };

  const totalCarton = detail.reduce((s, d) => s + Number(d.carton || 0), 0);

  const columns = detailColumns({ updateDetail, deleteDetail, readOnly: isView });

  return (
    <div className="delivery-note-manage">
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>

        {/* Toolbar */}
        <Flex justify="space-between" align="center">
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            {config?.title || "Delivery Note"}
          </Typography.Title>
          <Space>
            <Button size="small" className="bn-action" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
              ย้อนกลับ
            </Button>
            {!isView && (
              <Button type="primary" size="small" className="bn-action" icon={<SaveOutlined />} onClick={handleSave}>
                บันทึก
              </Button>
            )}
          </Space>
        </Flex>

        {/* Form Header */}
        <Card title="รายการส่งมอบสินค้าเพื่อส่งออก" loading={loading}>
          <Form form={form} layout="vertical" autoComplete="off" disabled={isView}>
            <Row gutter={[16, 0]}>
              {!isCreate && (
                <Col xs={24} sm={8} md={5}>
                  <Form.Item label="เลขที่ใบส่งมอบ" name="delcode">
                    <Input disabled />
                  </Form.Item>
                </Col>
              )}

              {/* JO — ปุ่มเปิด Modal */}
              <Col xs={24} sm={8} md={5}>
                <Form.Item
                  label="Job Order"
                  name="jocode"
                  rules={[{ required: true, message: "กรุณาเลือก Job Order" }]}
                >
                  <Input
                    readOnly
                    disabled={!isCreate}
                    placeholder="เลือก Job Order"
                    onClick={() => isCreate && setOpenJOModal(true)}
                    addonAfter={
                      isCreate ? (
                        <SearchOutlined
                          style={{ color: "#1677ff", cursor: "pointer" }}
                          onClick={() => setOpenJOModal(true)}
                        />
                      ) : null
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8} md={4}>
                <Form.Item label="โหลดที่" name="load_no">
                  <Input placeholder="ระบุโหลดที่" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8} md={5}>
                <Form.Item
                  label="วันที่ส่งมอบ"
                  name="dlvdate"
                  rules={[{ required: true, message: "กรุณาเลือกวันที่" }]}
                >
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 0]}>
              <Col xs={24} sm={10} md={8}>
                <Form.Item label="ลูกค้า" name="cusname">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6} md={5}>
                <Form.Item label="Brand" name="brand">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={11}>
                <Form.Item label="หมายเหตุ" name="remark">
                  <Input placeholder="หมายเหตุ" />
                </Form.Item>
              </Col>
              {/* hidden */}
              <Form.Item name="cuscode" hidden><Input /></Form.Item>
            </Row>
          </Form>
        </Card>

        {/* Detail Table */}
        <Card
          title="รายการสินค้า"
          extra={
            isCreate && (
              <Button
                size="small"
                type="primary"
                disabled={joItemsData.length === 0}
                onClick={() => setOpenJOItemsModal(true)}
              >
                + เพิ่มรายการ
              </Button>
            )
          }
        >
          <Table
            size="small"
            rowKey="seq"
            columns={columns}
            dataSource={detail}
            pagination={false}
            scroll={{ x: "max-content" }}
            summary={() => (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={4} align="right">
                  <Typography.Text strong>รวม</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <Typography.Text strong>{totalCarton.toLocaleString()}</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} />
              </Table.Summary.Row>
            )}
          />
        </Card>
      </Space>

      {/* Modal เลือก JO */}
      <ModalJobOrder
        show={openJOModal}
        close={() => setOpenJOModal(false)}
        selected={(record) => {
          setOpenJOModal(false);
          handleSelectJO(record);
        }}
      />

      {/* Modal เลือกรายการสินค้าจาก JO */}
      {openJOItemsModal && (
        <ModalJOItems
          show={openJOItemsModal}
          close={() => setOpenJOItemsModal(false)}
          joItems={joItemsData}
          onConfirm={handleConfirmJOItems}
        />
      )}
    </div>
  );
};

export default MyManage;
